import { memo } from 'react';
import { useSelector } from 'react-redux';

import Linkify from '~/components/Linkify';
import { useExternalLinksClickableContext } from '~/providers/ExternalLinksClickableProvider';
import { centralizedBoardDescriptionSelector } from '~/store/centralizedBoard/selectors';

export const PublicBoardHeaderDescription = memo(() => {
  const description = useSelector(centralizedBoardDescriptionSelector);
  const { areExternalLinksClickable } = useExternalLinksClickableContext();

  if (!description) {
    return null;
  }

  return (
    <p
      className="min-w-0 max-w-[750px] whitespace-pre-line break-words px-2 py-1 font-medium ads:text-metadata text-12 text-gray-10"
      data-testid="PUBLIC_BOARD_HEADER_DESCRIPTION"
      data-disableselect={true}
    >
      <Linkify disable={!areExternalLinksClickable}>{description}</Linkify>
    </p>
  );
});

PublicBoardHeaderDescription.displayName = 'PublicBoardHeaderDescription';
